/**
 * action types
 */
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USERS = 'UPDATE_USERS';
export const UPDATE_PROFILE_NAME_START = 'UPDATE_PROFILE_NAME_START';
export const UPDATE_PROFILE_NAME_SUCCESS = 'UPDATE_PROFILE_NAME_SUCCESS';
export const UPDATE_PROFILE_NAME_ERROR = 'UPDATE_PROFILE_NAME_ERROR';
export const UPDATE_PROFILE_IMAGE_START = 'UPDATE_PROFILE_IMAGE_START';
export const UPDATE_PROFILE_IMAGE_SUCCESS = 'UPDATE_PROFILE_IMAGE_SUCCESS';
export const UPDATE_PROFILE_IMAGE_ERROR = 'UPDATE_PROFILE_IMAGE_ERROR';
export const UPDATE_USER_FULLNAME = 'UPDATE_USER_FULLNAME';
